// import React, { useEffect } from "react";
// import PropTypes from "prop-types";
// import withRouter from "components/Common/withRouter";
// import { logoutUser } from "../../store/actions";

// //redux
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";

// const Logout = () => {
//   const history = useNavigate();
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(logoutUser(history));
//   }, [dispatch, history]);

//   return <></>;
// };

// Logout.propTypes = {
//   history: PropTypes.object,
// };

// export default withRouter(Logout);




import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_API;


const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const logout = async () => {
      const token = localStorage.getItem("token");

      try {
        await fetch(`${API}/usuarios/logout`, {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
      } catch (error) {
        console.error("Error cerrando sesión:", error);
      }

      // Limpiar el token y redirigir
      localStorage.removeItem("token");
      navigate("/login");
    };

    logout();
  }, [navigate]);

  return null;
};

export default Logout;
